import { func, object, string } from 'prop-types'
import GenericError from './GenericError'
import UnauthorizedError from './UnauthorizedError'

import './styles.scss'

const noop = () => {}

const ErrorDisplay = ({ currentError, joinBrand = noop, message }) => {
  const userNotMemberOfWorkspace =
    currentError &&
    currentError.error.response &&
    (currentError.error.response.status === 401 ||
      currentError.error.response.status === 403)

  if (userNotMemberOfWorkspace) {
    return <UnauthorizedError joinBrand={joinBrand} />
  }

  return <GenericError message={message} />
}

ErrorDisplay.propTypes = {
  currentError: object,
  joinBrand: func,
  message: string,
}

export default ErrorDisplay
